import React from 'react'
import Subheader from '../../component/Subheader'
import RoomFeature from '../RoomListing/RoomFeature'
import RoomLists from '../RoomListing/RoomLists'

export default function RoomlistingGoa() {
  const subheadData = {
    heading: 'Rooms & Suites in De Coracao',
    breadcrumb: [
      {
        slug: "/resort-de-coracao-goa",
        name: "Goa",
      },
      {
        slug: "",
        name: "Rooms",
      },
    ]
  }


  const roomList = [

        {
      category: "Standard Room",
      title: "Standard Room",
      description: "A warm and functional space designed for a comfortable stay, offering essential amenities and convenience.",
      image: "/image/goaroom-standard.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y",
      detailLink: "/resort-de-coracao-goa/standard-room",
      specs: [
        "1 King Size Bed",
        "2 Guests Occupancy",
        "21 m² Room Area",
      ],
    },
        {
      category: "Deluxe Room",
      title: "Deluxe Room",
      description: "Bright and welcoming, these rooms combine contemporary comfort with coastal charm, perfect for a relaxing escape.",
      image: "/image/goaroom-deluxe.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y",
      detailLink: "/resort-de-coracao-goa/deluxe-room",
      specs: [
        "1 King Size Bed",
        "2 Guests Occupancy",
        "24 m² Room Area",
      ],
    },
    
    {
      category: "Super Deluxe",
      title: "Super Deluxe Room",
      description: "Enjoy a more spacious stay with thoughtful touches, created to offer greater comfort, relaxation, and luxury.",
      image: "/image/goaroom-superdeluxe.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y",
      detailLink: "/resort-de-coracao-goa/super-deluxe-room",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "28 m² Room Area",
      ],
    },
    {
      category: "Premium Room",
      title: "Premium Room",
      description: "Enjoy elevated comfort in our spacious premium rooms, featuring refined finishes and a layout designed for complete relaxation.",
      image: "/image/goaroom-premium.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y",
      detailLink: "/resort-de-coracao-goa/premium-room",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "30 m² Room Area",
      ],
    },

    {
      category: "Suite Room",
      title: "Suite Room",
      description: "Our most spacious offering, featuring a separate living area and master bedroom for those seeking a true home-away-from-home experience.",
      image: "/image/goaroom-suite.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y",
      detailLink: "/resort-de-coracao-goa/suite-room",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "37 m² Room Area",
      ],
    },







    // {
    //   category: "Corner Deluxe",
    //   title: "Corner Deluxe Room",
    //   description:"Enjoy a bright and airy corner retreat featuring dual-aspect views and enhanced privacy, designed for those who appreciate natural light and extra space.",
    //   image: "/image/goaroom-cornerdeluxe.webp",
    //   enquireLink: "/contact-us",
    //   bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y",
    //   detailLink: "/resort-de-coracao-goa/corner-deluxe-room",
    //   specs: [
    //     "1 King Size Bed",
    //     "3 Guests Occupancy",
    //     "45 m² Room Area",
    //   ],
    // },
  ];


const roomFeatureData = {
  features1: [
    {
      icon: "/image/room-feature-icon-1.webp",
      text: "Discover warm, personalized hospitality that makes your Goa accommodation welcoming, comfortable, and memorable.",
    },
    {
      icon: "/image/room-feature-icon-2.webp",
      text: "Relax in tranquil outdoor spaces, perfect for unwinding and enjoying Goa’s laid-back coastal charm.",
    },
    {
      icon: "/image/room-feature-icon-3.webp",
      text: "Savour thoughtfully prepared dishes featuring fresh ingredients, vibrant flavours, and memorable dining experiences.",
    },
  ],

  features2: [
    {
      icon: "/image/room-feature-icon-4.webp",
      text: "Find accommodation beyond the ordinary, offering a calming retreat where every detail helps you recharge.",
    },
    {
      icon: "/image/room-feature-icon-5.webp",
      text: "Explore beautifully designed spaces featuring natural materials and refined details inspired by Goa’s relaxed character.",
    },
    {
      icon: "/image/room-feature-icon-6.webp",
      text: "Choose from thoughtfully designed stay listings with quality amenities, comfortable rooms, and restful spaces.",
    },
  ],
};

  return (
    <>
      <Subheader subheadData={subheadData} />
      <RoomLists roomList={roomList} />
      <RoomFeature data={roomFeatureData}/>
    </>
  )
}
